import { provide, defineComponent, reactive, watch, onUnmounted } from 'vue';
import PropTypes from '../_util/vue-types';
import moment from 'moment';
import interopDefault from '../_util/interopDefault';
import { changeConfirmLocale } from '../modal/locale';
import warning from '../_util/warning';
import { withInstall } from '../_util/type';
export const ANT_MARK = 'internalMark';
function setMomentLocale(locale) {
    if (locale && locale.locale) {
        interopDefault(moment).locale(locale.locale);
    }
    else {
        interopDefault(moment).locale('en');
    }
}
const LocaleProvider = defineComponent({
    name: 'ALocaleProvider',
    props: {
        locale: {
            type: Object,
        },
        ANT_MARK__: PropTypes.string,
    },
    setup(props, { slots }) {
        warning(props.ANT_MARK__ === ANT_MARK, 'LocaleProvider', '`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead');
        const state = reactive({
            antLocale: Object.assign(Object.assign({}, props.locale), { exist: true }),
            ANT_MARK__: ANT_MARK,
        });
        provide('localeData', state);
        watch(() => props.locale, val => {
            state.antLocale = Object.assign(Object.assign({}, val), { exist: true });
            setMomentLocale(val);
            changeConfirmLocale(val && val.Modal);
        }, { immediate: true });
        onUnmounted(() => {
            changeConfirmLocale();
        });
        return () => {
            var _a;
            return (_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots);
        };
    },
});
/* istanbul ignore next */
LocaleProvider.install = function (app) {
    app.component(LocaleProvider.name, LocaleProvider);
    return app;
};
export default withInstall(LocaleProvider);
